// extracted by mini-css-extract-plugin
export default {"title":"title___N1PVP","intro":"intro___dXiwE"};